(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vellumo-almohada"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.vhReady) return;
      root.dataset.vhReady = '1';

      // Packs: el botón y la barra fija muestran el texto y el precio del pack elegido;
      // el número pasa del precio anterior al nuevo en ~250 ms.
      var prices = root.querySelectorAll('[data-vh-price]');
      var atcLabel = root.querySelector('[data-vh-atc-label]');
      var stickyName = root.querySelector('[data-vh-sticky-name]');
      var variantInput = root.querySelector('[data-vh-variant]');
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var packs = root.querySelector('[data-vh-packs]');
      var money = new Intl.NumberFormat(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (packs && packs.dataset.currency) || 'EUR'
      });
      var checked = packs && packs.querySelector('input:checked');
      var current = checked ? Number(checked.dataset.cents) : 0;
      var frame;
      var showPrice = function (cents) {
        prices.forEach(function (el) { el.textContent = money.format(cents / 100); });
      };
      var animatePrice = function (to) {
        cancelAnimationFrame(frame);
        var from = current;
        current = to;
        if (reduceMotion || from === to) return showPrice(to);
        var start = performance.now();
        var step = function (now) {
          var t = Math.min((now - start) / 250, 1);
          var eased = 1 - Math.pow(1 - t, 3);
          showPrice(t < 1 ? Math.round(from + (to - from) * eased) : to);
          if (t < 1) frame = requestAnimationFrame(step);
        };
        frame = requestAnimationFrame(step);
      };
      root.querySelectorAll('[data-vh-packs] input[name="quantity"]').forEach(function (input) {
        input.addEventListener('change', function () {
          // El kit es otro producto: cambia la variante que se envía al carrito
          if (variantInput) variantInput.value = input.dataset.variant;
          if (atcLabel && !atcLabel.hasAttribute('data-vh-atc-fixed')) atcLabel.textContent = input.dataset.atc;
          if (stickyName) stickyName.textContent = input.dataset.label;
          animatePrice(Number(input.dataset.cents));
        });
      });

      // Botón del pack 1 que elige otro pack (p. ej. «llévate 2»).
      root.querySelectorAll('[data-vh-pick]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var radio = root.querySelector('.vh-pack--' + btn.dataset.vhPick + ' input[name="quantity"]');
          if (!radio) return;
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          radio.focus({ preventScroll: true });
        });
      });

      // Barra fija: visible cuando el botón principal no está en pantalla.
      var sticky = root.querySelector('[data-vh-sticky]');
      var atc = root.querySelector('[data-vh-atc]');
      if (sticky && atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var show = !entries[0].isIntersecting;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          var btn = sticky.querySelector('button');
          if (btn) btn.tabIndex = show ? 0 : -1;
        }).observe(atc);
      }

      // Insignias: aparecen suavemente al entrar en pantalla (nada si se prefiere menos movimiento).
      var badges = root.querySelector('[data-vh-badges]');
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (badges && !calm && 'IntersectionObserver' in window) {
        badges.classList.add('is-anim');
        var badgeIo = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          badges.classList.add('is-in');
          badgeIo.disconnect();
        }, { threshold: 0.25 });
        badgeIo.observe(badges);
      }

      // Galería: miniaturas sincronizadas con el carrusel.
      var track = root.querySelector('[data-vh-track]');
      var thumbs = root.querySelectorAll('[data-vh-thumb]');
      if (track && thumbs.length) {
        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            track.scrollTo({ left: Number(thumb.dataset.vhThumb) * track.clientWidth, behavior: 'smooth' });
          });
        });
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var i = Math.round(track.scrollLeft / track.clientWidth);
            thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
            ticking = false;
          });
        }, { passive: true });
      }

      // Pestañas accesibles (sin JS se ven todos los paneles).
      root.querySelectorAll('[data-vh-tabs]').forEach(function (wrap) {
        var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
        var select = function (tab, focus) {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.tabIndex = on ? 0 : -1;
            var panel = document.getElementById(t.getAttribute('aria-controls'));
            if (panel) panel.hidden = !on;
          });
          if (focus) tab.focus();
        };
        tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () { select(tab); });
          tab.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight') select(tabs[(i + 1) % tabs.length], true);
            if (e.key === 'ArrowLeft') select(tabs[(i - 1 + tabs.length) % tabs.length], true);
          });
        });
        if (tabs.length) select(tabs[0]);
      });

      // Comparador antes / después.
      root.querySelectorAll('[data-vh-compare]').forEach(function (cmp) {
        var range = cmp.querySelector('input[type="range"]');
        if (range) range.addEventListener('input', function () { cmp.style.setProperty('--pos', range.value + '%'); });
      });

      // Modelo 3D nativo de Shopify: la librería solo se carga si hay modelo
      // y cuando la galería se acerca a la pantalla.
      var model = root.querySelector('[data-vh-model] model-viewer');
      if (model && window.Shopify && Shopify.loadFeatures && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: function (err) { if (!err && window.Shopify.ModelViewerUI) new Shopify.ModelViewerUI(model); }
            },
            {
              name: 'shopify-xr',
              version: '1.0',
              onLoad: function (err) {
                var data = root.querySelector('script[id^="ProductJSON-3d-"]');
                if (err || !data || !window.ShopifyXR) return;
                window.ShopifyXR.addModels(JSON.parse(data.textContent));
                window.ShopifyXR.setupXRElements();
              }
            }
          ]);
        }, { rootMargin: '200px' });
        io.observe(model);
      }
    }

    function boot() { document.querySelectorAll('[data-vh]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vellumo-header"]) return;
  try {
    
  (function () {
    // En la portada: la cabecera se vuelve blanca y muestra "Comprar" al hacer scroll.
    function init() {
      var header = document.querySelector('[data-vhh]');
      if (!header || !header.classList.contains('vhh--overlay') || header.dataset.ready) return;
      header.dataset.ready = '1';
      var buy = header.querySelector('.vhh__buy');
      var update = function () {
        var solid = window.scrollY > 24;
        header.classList.toggle('is-solid', solid);
        if (buy) buy.tabIndex = solid ? 0 : -1;
      };
      update();
      window.addEventListener('scroll', update, { passive: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  (function () {
    // App de contra reembolso (Releasit): su botón dice «24/48h»; la tienda promete 24/72 h.
    // Corrige el texto cada vez que la app pinta o repinta el botón y su barra fija.
    var WRONG = /24\s*[\/-]\s*48\s*h(oras)?/gi;
    var RIGHT = '24/72 h';
    function fix(root) {
      var scopes = root.querySelectorAll ? root.querySelectorAll('#rsi_buy_now_button, #floatingBuyNowButton') : [];
      scopes.forEach(function (scope) {
        var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
        var node;
        while ((node = walker.nextNode())) {
          if (WRONG.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(WRONG, RIGHT);
          WRONG.lastIndex = 0;
        }
      });
    }
    function start() {
      fix(document);
      new MutationObserver(function () { fix(document); }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vellumo-intro-3d"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Solo si hay modelo 3D: carga el visor nativo de Shopify y hace el mismo "deszoom" con la cámara.
    function init(root) {
      if (root.dataset.v3dReady) return;
      root.dataset.v3dReady = '1';
      var wrap = root.querySelector('[data-v3d-model]');
      var mv = wrap && wrap.querySelector('model-viewer');
      if (!mv || !window.Shopify || !Shopify.loadFeatures) return;
      Shopify.loadFeatures([{
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: function (err) {
          if (err) return;
          mv.addEventListener('load', function () {
            wrap.classList.add('is-ready');
            var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            requestAnimationFrame(function () {
              mv.setAttribute('camera-orbit', '25deg 68deg 105%');
              setTimeout(function () { if (!reduce) mv.setAttribute('auto-rotate', ''); }, 1200);
            });
          }, { once: true });
        }
      }]);
    }
    function boot() { document.querySelectorAll('[data-v3d]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
